import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
export interface AssetsState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allAssets: [] | null | any;
  assetRiskAssessmentData: {} | null | any;
}
const initialState: AssetsState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  allAssets: null,
  assetRiskAssessmentData: null,
};
export const assetsSlice = createSlice({
  name: 'Assets',
  initialState,
  reducers: {
    setAllAssets: (state, action) => {
      state.allAssets = action.payload.data;
    },
    setAssets: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    setAllAssetsBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    setAssetRiskAssessment: (state, action) => {
      state.assetRiskAssessmentData = action.payload.data;
    },
    reset: (state) => {
      state = initialState;
    },
  },
});
// Action creators are generated for each case reducer function
export const { setAllAssets, setAssets, setAllAssetsBySearch, setAssetRiskAssessment, reset } = assetsSlice.actions;
export const allAssetsDetails = (state: RootState) => state.assets.allAssets;
export const getAllAssetsDetails = (state: RootState) => state.assets.data;
export const getAssetsTotalRecords = (state: RootState) => state.assets.totalRecords;
export const getAllAssetsBySearch = (state: RootState) => state.assets.data;
export const getAssetRiskAssessmentData = (state: RootState) => state.assets.assetRiskAssessmentData;
export default assetsSlice.reducer;